import User from '../organisation/user';
import { formatISO, parseISO } from 'date-fns';
import ReportDto from './report-dto';
export default class Report {
    constructor(dto) {
        this.pinned = false;
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get project() {
        if (!this.dto.project) {
            return null;
        }
        return this.dto.project.replace('/projects/', '');
    }
    set project(project) {
        if (project) {
            this.dto.project = project;
        }
        else {
            this.dto.project = null;
        }
    }
    get user() {
        if (!this.dto.user) {
            return null;
        }
        return new User(this.dto.user);
    }
    set user(user) {
        if (user) {
            this.dto.user = user.dto;
        }
        else {
            this.dto.user = null;
        }
    }
    get report() {
        return this.dto.report;
    }
    set report(report) {
        this.dto.report = report;
    }
    get title() {
        return this.dto.title;
    }
    set title(title) {
        this.dto.title = title;
    }
    get description() {
        return this.dto.description;
    }
    set description(description) {
        this.dto.description = description;
    }
    get config() {
        return this.dto.config;
    }
    set config(config) {
        this.dto.config = config;
    }
    get dateCreated() {
        return parseISO(this.dto.dateCreated);
    }
    set dateCreated(dateCreated) {
        this.dto.dateCreated = formatISO(dateCreated);
    }
    get dateUpdated() {
        return parseISO(this.dto.dateUpdated);
    }
    set dateUpdated(dateUpdated) {
        this.dto.dateUpdated = formatISO(dateUpdated);
    }
    /**
     * Generates a report from a SavedSearchInterface
     *
     * @param savedSearch
     * @returns
     */
    static createFromSavedSearchInterface(savedSearch) {
        const report = new Report(new ReportDto());
        report.id = savedSearch.id;
        report.title = savedSearch.title;
        report.description = savedSearch.description;
        report.config = savedSearch.config;
        report.pinned = savedSearch.pinned;
        report.dateCreated = parseISO(savedSearch.dateCreated);
        report.dateUpdated = parseISO(savedSearch.dateUpdated);
        return report;
    }
    /**
     * Returns a SavedSearchInterface compatible object
     *
     * @returns
     */
    toSavedSearchInterface() {
        const savedSearch = {
            id: this.id,
            title: this.title,
            description: this.description,
            config: this.config,
            pinned: this.pinned,
            dateCreated: this.dto.dateCreated,
            dateUpdated: this.dto.dateUpdated,
        };
        return savedSearch;
    }
    get params() {
        const data = {
            report: this.report,
            title: this.title,
            description: this.description,
            config: this.config,
        };
        if (this.project) {
            data.project = `/projects/${this.project}`;
        }
        return data;
    }
}
//# sourceMappingURL=report.js.map